import React from "react";
import { hero } from "../../../dummyData";
import "./hero.css";
import Card from "./Card";

const Hero = () => {
  // const [items, setIems] = useState(hero);
  const items = hero;

  return (
    <>
      <section className="hero">
        <div className="container">
          {items.map((item) => {
            return (
              <>
                <Card key={item.id} item={item} />
              </>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Hero;
